<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { useTemplateRef } from "vue";
import { cn } from "@/utils/shadcn"

const props = defineProps<{ class?: HTMLAttributes["class"] }>();

const elRef = useTemplateRef('el');

defineExpose({
  el: elRef,
});
</script>

<template>
  <div
    data-slot="dialog-footer"
    :class="cn('flex flex-col-reverse gap-2 sm:flex-row sm:justify-end', props.class)"
    ref="el"
  >
    <slot></slot>
  </div>
</template>
